export default "__VITE_ASSET__CZWt4$NL__"